export function validateJsonSchemaFormData(schema, formData = {}) {
  if (!schema || typeof schema !== "object" || schema.type !== "object") {
    return [];
  }

  const errors = [];
  const properties = schema.properties || {};
  const requiredFields = schema.required || [];

  requiredFields.forEach((key) => {
    const value = formData[key];
    if (value === undefined || value === null || value === "") {
      errors.push({ key, message: "Campo requerido" });
    }
  });

  Object.entries(properties).forEach(([key, propSchema]) => {
    const value = formData[key];
    if (value === undefined || value === null || value === "") {
      return;
    }

    if ((propSchema.type === "number" || propSchema.type === "integer") && value !== "") {
      const numeric = Number(value);
      if (Number.isNaN(numeric)) {
        errors.push({ key, message: "Debe ser un número" });
        return;
      }

      if (propSchema.minimum !== undefined && numeric < propSchema.minimum) {
        errors.push({ key, message: `Debe ser ≥ ${propSchema.minimum}` });
      }

      if (propSchema.maximum !== undefined && numeric > propSchema.maximum) {
        errors.push({ key, message: `Debe ser ≤ ${propSchema.maximum}` });
      }
    }
  });

  return errors;
}